import { Component, OnInit, Input } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-transfer-medico',
    templateUrl: './transfer-medico.component.html',
    styleUrls: ['./transfer-medico.component.scss'],
    standalone: false
})
export class TransferMedicoComponent implements OnInit {

  public DoctorList$: any;
  @Input() FormElement: UntypedFormControl;

  constructor(private selectionService: SelectionGenericService) { }

  ngOnInit(): void {
    this.selectionService.GetDoctorList().subscribe(res => {
      if (res.code === 0) {
        this.DoctorList$ = res.result;
      }
    }, error => {
      console.error(error);
    });
  }

}
